import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const normalizeUrl = (value = "") => value.trim().replace(/\/+$/, "");

const LOCAL_API_BASE_URL = "http://localhost:5000/api/v1";
const LOCAL_ASSET_URI = "http://localhost:5000";
const PRODUCTION_API_BASE_URL = "https://api.help.asefo.org/api/v1";
const PRODUCTION_ASSET_URI = "https://api.help.asefo.org";

const isLocalBrowser =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const rawApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  (isLocalBrowser ? LOCAL_API_BASE_URL : PRODUCTION_API_BASE_URL);
export const PROXY = normalizeUrl(rawApiBaseUrl);

const rawAssetUri =
  process.env.REACT_APP_ASSET_URI ||
  (isLocalBrowser ? LOCAL_ASSET_URI : PRODUCTION_ASSET_URI);
export const ASSET_URI = normalizeUrl(rawAssetUri);

if (
  typeof window !== "undefined" &&
  window.location.protocol === "https:" &&
  PROXY.startsWith("http://")
) {
  console.error(
    "Mixed content: HTTPS frontend cannot call HTTP backend. Set REACT_APP_API_BASE_URL to an HTTPS API URL.",
  );
}

export const limitCharecters = (str, limit) =>
  str?.length > +limit ? `${str?.substring(0, +limit)}...` : str;

export const capitalizeFirstLetter = (word) => {
  return word?.charAt(0)?.toUpperCase() + word?.slice(1);
};

export const removeBgPrefix = (bgClass) => {
  return bgClass.replace("bg-", "text-");
};

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const fetchData = async (url, accessToken) => {
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }

  return response.json();
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// * ✅ Simple localStorage cache with expiry */
export const setCache = (key, data, ttlHours = 1) => {
  const expiry = Date.now() + ttlHours * 60 * 60 * 1000;
  localStorage.setItem(key, JSON.stringify({ data, expiry }));
};

export const getCache = (key) => {
  const cached = localStorage.getItem(key);
  if (!cached) return null;
  try {
    const { data, expiry } = JSON.parse(cached);
    if (Date.now() > expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return data;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
};
